export default "__VITE_ASSET__f29fc016__"